import React, { useState } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { Icon } from '../../../components';
import { sendAlert } from '../../../actions/utils';
import { createCompanyTaskRequest, updateCompanyTaskRequest } from '../../../requests/companyTasks';
import CompanyTaskDatatable from '../../CompanyTask/CompanyTaskDatatable';
import CompanyTaskForm from '../../Shared/CompanyTask/CompanyTaskForm';
import defaultTask from '../../Shared/CompanyTask/task';
import BossTasksFilter from './BossTasksFilter';
import BossTaskShow from './BossTaskShow';

const formatDate = date => {
  if (typeof date.format === 'function') return date.format('DD-MM-YYYY');
  if (typeof date === 'string') return date.replace(/\//g, '-');
  return date;
};

const BossTasksPanel = ({ employees, employeeIds, currentEmployee }) => {
  const dispatch = useDispatch();
  const { currentEmployee: currentEmployeeId } = useSelector(state => state.auth);
  const [view, setView] = useState('list');
  const [editTask, setEditTask] = useState(null);
  const [filters, setFilters] = useState({});
  const [moreData, setMoreData] = useState(false);
  const [hasFiltered, setHasFiltered] = useState(false);

  const bossEmployeeFilter = employeeIds && employeeIds.length > 0 ? { filter_employee: employeeIds } : {};

  const handleFilterSubmit = values => {
    const params = {};
    if (values.filterEmployee) {
      params.filter_employee = [values.filterEmployee];
    } else if (employeeIds && employeeIds.length > 0) {
      params.filter_employee = employeeIds;
    }
    if (values.filterTitle) params.filter_title = values.filterTitle;
    if (values.filterPriority !== '') params.filter_priority = values.filterPriority;
    if (values.dateRange && values.dateRange.length === 2) {
      params.date_range = `${formatDate(values.dateRange[0])},${formatDate(values.dateRange[1])}`;
    }
    setFilters(params);
    setHasFiltered(true);
    setMoreData(prev => !prev);
  };

  const handleCreate = (taskValues, setSubmitting) => {
    createCompanyTaskRequest({
      dispatch,
      params: snakeCaseKeys(taskValues),
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Tarea creada con éxito' }));
        setView('list');
        setMoreData(prev => !prev);
      },
      callback: () => setSubmitting(false)
    });
  };

  const handleUpdate = (taskValues, setSubmitting) => {
    updateCompanyTaskRequest(editTask.id, {
      dispatch,
      params: snakeCaseKeys(taskValues),
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Tarea actualizada con éxito' }));
        setView('list');
        setEditTask(null);
        setMoreData(prev => !prev);
      },
      callback: () => setSubmitting(false)
    });
  };

  const handleEditAction = item => {
    setEditTask(camelCaseRecursive(item));
    setView('edit');
  };

  const handleShowAction = item => {
    setEditTask(camelCaseRecursive(item));
    setView('show');
  };

  const handleBack = () => {
    setView('list');
    setEditTask(null);
  };

  const customParams = { ...bossEmployeeFilter, ...filters };

  return (
    <Card className="mb-1">
      <Col className="top-header-green">
        <Col className="card-header-title">Tareas</Col>
      </Col>
      <Col sm={12} md={12} lg={12} className="mt-2">
        {view === 'list' && (
          <>
            <Row className="justify-content-end px-3 mt-2">
              <Button
                variant="primary"
                onClick={() => {
                  setEditTask(null);
                  setView('new');
                }}
              >
                NUEVO
              </Button>
            </Row>
            <BossTasksFilter
              formRequest={handleFilterSubmit}
              employees={employees.filter(e => e.value !== '' && e.label !== 'Todos')}
            />
            {hasFiltered ? (
              <CompanyTaskDatatable
                customParams={customParams}
                moreDataOverride={moreData}
                onEditAction={handleEditAction}
                onShowAction={handleShowAction}
              />
            ) : (
              <div className="text-center py-4 text-muted">No se encontraron datos.</div>
            )}
          </>
        )}

        {(view === 'new' || view === 'edit') && (
          <>
            <Row className="px-3 mt-2 mb-2">
              <Button variant="circle-dark" className="btn-circle" onClick={handleBack}>
                <Icon icon="chevron-back" />
              </Button>
            </Row>
            <CompanyTaskForm
              companyTask={editTask || { ...defaultTask, employeeId: currentEmployee || currentEmployeeId }}
              action={view}
              formRequest={view === 'edit' ? handleUpdate : handleCreate}
              rrhh={false}
              currentEmployee={currentEmployee || currentEmployeeId}
            />
          </>
        )}

        {view === 'show' && editTask && <BossTaskShow taskId={editTask.id} handleBack={handleBack} />}
      </Col>
    </Card>
  );
};

export default BossTasksPanel;
